import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Mesa } from '../../../models/mesa';
import { SalaService } from '../../../services/sala.service';
import { Sala } from '../../../models/sala';
import { PedidoService } from '../../../services/pedido.service';
import { Pedido } from '../../../models/pedido';

@Component({
  selector: 'app-sala-mesa-modal',
  templateUrl: './sala-mesa-modal.component.html',
  styleUrls: ['./sala-mesa-modal.component.css'],
  providers:[
    SalaService,
    PedidoService
  ]
})
export class SalaMesaModalComponent implements OnInit {
  public loading:Boolean;
  @Output() sendMesa =  new EventEmitter();

  public salas: Array<Sala>;

  constructor(
    private salaService: SalaService,
    private pedidoService: PedidoService,
    public bsModalRef: BsModalRef,
  ) {
    this.loading = false;
    this.salas = [];
  }

  ngOnInit() {
    this.getSalas();
  }

  getSalas() {
    this.loading = true;
    //let qs = "";//"?embed=mesas&sort=id";
    this.salaService.getAll("?pedidos.is_facturado=0").subscribe(
      res => {
        
        let salas: Array<Sala> = res.data;
        let indexSala = 0;
        let salaSelected = undefined;

        for(let sala of salas){
          sala.mesas = this.groupMesas(sala.mesas);
          for(let mesa of sala.mesas){
            if( mesa.is_para_llevar ){
              salaSelected = sala;
              break;
            }
          }
          if( salaSelected ) break;
          indexSala++;
        }

        salas.splice(indexSala, 1);
        this.salas = salas;
        this.salas.push(salaSelected);

        this.loading = false;
      },
      er => {
        this.loading = false;
      }
    );
  }

  getPedidosByMesas(mesa_id){
    return new Promise((resolve, reject) => {
      this.pedidoService.getAll("?mesa_id=" + mesa_id + "&is_facturado=0").subscribe(
        res => resolve(res.data),
        err => reject(err),
      );
    });
  }

  groupMesas(mesas: Array<Mesa>){
    let data = [];
    let list = [];
    let isPush = false;

    if( mesas && mesas.length ){
      mesas.forEach(mesa => {
        isPush = false;
  
        list.push(mesa);
  
        if( list.length == 4 ){
          data.push(list);
          list = [];
          isPush = true;
        }
      });
  
      if ( !isPush ) data.push(list);
    }

    return data;
  }

  onSendMesa(mesa) {
		//envía de objecto usuario
		this.sendMesa.emit(mesa.id);
		//Cierre de modal o componente
		this.bsModalRef.hide();
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/sala-mesa-modal/sala-mesa-modal.component.ts